<template>
    <div class="cbs-mobile-container">
        <detail-frame
            biz-type="COMREG"
            :base-info="baseInfo"
            :tab-list="tabList"
            @onToBuy="onToBuy"
        >
            <template v-slot:product-detail>
                <div class="detail-item">
                    <div class="detail-item-title">{{ productInfo.modileTitle }}</div>
                    <div class="detail-item-sub">{{ productInfo.infoDesc }}</div>
                    <div class="hot-service-wrap">
                        <div
                            v-for="(item, index) in productInfo.infoList"
                            :key="index"
                            class="hot-service"
                        >
                            <div class="hot-service-title">{{ item.title }}</div>
                            <div class="hot-service-content">{{ item.content }}</div>
                            <div class="hot-service-tag">
                                <span v-for="(tag, tagIndex) in item.tag" :key="tagIndex">
                                    {{ tag }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="detail-item">
                    <div class="detail-item-title">{{ advantage.title }}</div>
                    <div class="advantage-wrap">
                        <div
                            v-for="(item, index) in advantage.infoList"
                            :key="index"
                            class="advantage-item"
                        >
                            <div :class="['advantage-img', item.className]"></div>
                            <div class="advantage-title">{{ item.title }}</div>
                            <div class="advantage-content">
                                <p v-for="(info, infoIndex) in item.info" :key="infoIndex">
                                    {{ info }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="detail-item specity-color">
                    <div class="detail-item-title">{{ process.title }}</div>
                    <div class="detail-item-sub">{{ process.infoDesc }}</div>
                    <div class="process-img"></div>
                </div>
                <div class="detail-item">
                    <div class="detail-item-title">{{ material.title }}</div>
                    <div class="material-wrap">
                        <div class="material-img"></div>
                        <div class="material-detail">
                            <div
                                v-for="(item, index) in material.infoList"
                                :key="index"
                                class="material-detail-item"
                            >
                                <div class="material-detail-title">
                                    <i class="gou-icon"></i>
                                    {{ item.title }}
                                </div>
                                <div class="material-detail-content">{{ item.content }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="detail-item">
                    <div class="detail-item-title">{{ question.title }}</div>
                    <div class="question-wrap">
                        <div
                            v-for="(item, index) in question.infoList"
                            :key="index"
                            class="question-item"
                        >
                            <div :class="['item-left', 'question-index']">Q{{ index + 1 }}</div>
                            <div class="item-right">
                                <div class="question-title">{{ item.title }}</div>
                                <div class="question-content">{{ item.content }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:drawer>
                <crs-optional ref="optional"></crs-optional>
            </template>
        </detail-frame>
    </div>
</template>

<script>
import {stringify} from 'qs';
import {resetRem, checkTwo} from '../../util/helper';
import DetailFrame from '../../components/mobile/detailFrame.vue';
import CrsOptional from '../../components/mobile/cbsOptional.vue';
import {productIntroTabSource} from '../data/global';
import {
    baseInfoModile, productInfo, advantage, process,
    material, question, metaInfo
} from '../data/cbs';

export default {
    metaInfo,

    props: {
        activetab: {
            type: String,
            default: 'intro'
        }
    },

    components: {
        DetailFrame,
        CrsOptional
    },

    data() {
        return {
            isShowDialog: false,
            tabList: productIntroTabSource.CRS,
            baseInfo: baseInfoModile,
            productInfo,
            advantage,
            process,
            material,
            question
        };
    },

    created() {
        resetRem();
        // 判断是否在手百内，手百内需要进行二次验证
        checkTwo();
    },

    methods: {
        onChangeFormDate(type, value) {
            this.formData[type] = value;
        },

        onScrollDetail(index) {
            window.scrollTo({
                top: this.scrollHeightList[index],
                behavior: 'smooth'
            });
        },

        onHideDialog() {
            this.isShowDialog = false;
        },

        onShowDialog() {
            this.isShowDialog = true;
        },

        onToBuy() {
            this.$refs.optional.getFormData().then(data => {
                const url = '#/order/crs/confirm?';
                window.location.href = url + stringify(data);
            });
        }
    }
};
</script>

<style lang="less">
.cbs-mobile-container {
    background-color: #F5F5F5;
    padding-bottom: 12.8rem;

    .detail-item {
        padding: 0 3.4rem;
        background-color: #FFF;
        .detail-item-title {
            font-family: PingFangSC-Medium;
            font-size: 3.8rem;
            color: #1B1E3F;
            letter-spacing: 0;
            text-align: center;
            font-weight: 500;
            padding: 4rem 0 1.6rem 0;
        }
        .detail-item-sub {
            opacity: 0.6;
            font-family: PingFangSC-Regular;
            font-size: 2.6rem;
            color: #1B1E3F;
            letter-spacing: 0;
            text-align: center;
            font-weight: 400;
            margin-bottom: 2.8rem;
        }
    }

    .hot-service-wrap {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .hot-service {
            background: #FFF;
            border: 0.1rem solid #2A62FE;
            box-shadow: 0.2rem 0.2rem 1.4rem 0 rgba(25,28,61,0.08);
            border-radius:0.4rem;
            padding: 1.8rem 2rem 2rem 2rem;
            width: 48%;
            max-width: 32.6rem;
            box-sizing: border-box;
            margin-bottom: 3rem;
        }
        .hot-service-title {
            font-family: PingFangSC-Medium;
            font-size: 2.8rem;
            color: #2A62FE;
            letter-spacing: 0;
            font-weight: 500;
            padding-bottom: 1.8rem;
            border-bottom: 0.1rem solid #E1E6F0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .hot-service-content {
            opacity: 0.5;
            font-family: PingFangSC-Regular;
            font-size: 2.4rem;
            color: #1B1E3F;
            letter-spacing: 0;
            font-weight: 400;
            padding-top: 1.8rem;
            height: 16.3rem;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
        }
        .hot-service-tag {
            span {
                font-family: PingFangSC-Regular;
                font-size: 1.2rem;
                color: #2A62FE;
                letter-spacing: 0;
                font-weight: 400;
                padding: 0.5rem;
                border: 0.1rem solid #2A62FE;
                border-radius: 0.4rem;
                margin-right: 1.5rem;
                margin-top: 1rem;
                display: inline-block;
            }
        }
    }

    .advantage-wrap {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .advantage-item {
            width: 48%;
            max-width: 31.6rem;
            margin-bottom: 3rem;
        }

        .advantage-img {
            width: 9.13rem;
            height: 10rem;
            background-size: 100%;
            background-repeat: no-repeat;
            margin: auto;
        }

        .advantage-title {
            font-family: PingFangSC-Medium;
            font-size: 2.8rem;
            color: #2A62FE;
            letter-spacing: 0;
            font-weight: 500;
            text-align: center;
            margin: 2rem 0 1.8rem 0;
        }

        .advantage-content {
            opacity: 0.5;
            font-family: PingFangSC-Regular;
            font-size: 2.4rem;
            color: #1B1E3F;
            letter-spacing: 0;
            font-weight: 400;
            text-align: center;
            p {
                text-align: left;
                margin-bottom: 1rem;
            }
        }
        .advantage1 {
            background-image: url(../../assets/mobile/cbs/advantage1.png);
        }
        .advantage2 {
            background-image: url(../../assets/mobile/cbs/advantage2.png);
        }
        .advantage3 {
            background-image: url(../../assets/mobile/cbs/advantage3.png);
        }
        .advantage4 {
            background-image: url(../../assets/mobile/cbs/advantage4.png);
        }
    }

    .process-img {
        height: 40rem;
        max-height: 220px;
        background-image: url(../../assets/mobile/cbs/process.png);
        background-size: 100% 100%;
    }

    .material-wrap {
        .material-img {
            height: 30rem;
            max-height: 165px;
            background-image: url(../../assets/mobile/cbs/material.png);
            background-size: 100% 100%;
        }
        .material-detail {
            display: flex;
            flex-wrap: wrap;
        }
        .material-detail-item {
            max-width: 43.2rem;
            margin-top: 2.8rem;
        }
        .material-detail-item:nth-child(2n+1) {
            margin-right: 6.8rem;
        }
        .material-detail-title {
            font-family: PingFangSC-Medium;
            font-size: 2.8rem;
            color: #1B1E3F;
            letter-spacing: 0;
            font-weight: 500;
            margin-bottom: 1.8rem;
            display: flex;
            align-items: center;
        }
        .material-detail-content {
            opacity: 0.5;
            font-family: PingFangSC-Regular;
            font-size: 2.4rem;
            color: #1B1E3F;
            letter-spacing: 0;
            font-weight: 400;
        }
        .gou-icon {
            width: 2.4rem;
            height: 2.4rem;
            background-image: url(../../assets/mobile/cbs/gou.png);
            background-size: 100% 100%;
            display: inline-block;
            margin-right: 2rem;
        }
    }

    .question-wrap {
        padding-bottom: 4rem;
        .question-item {
            margin-bottom: 2.8rem;
            display: flex;
        }
        .item-left {
            width: 3.8rem;
            height: 3.2rem;
            background-image: url('https://cbs-public.cdn.bcebos.com/portal/20220809/tip.png');
            background-size: 100%;
            background-repeat: no-repeat;
            margin: 0.5rem 2rem 0 0;
        }
        .question-index {
            color: #FFF;
            line-height: 2.4rem;
            text-align: center;
        }
        .item-right {
            width: 62.4rem;
        }
        .question-title {
            font-family: PingFangSC-Medium;
            font-size: 3rem;
            color: #1B1E3F;
            letter-spacing: 0;
            font-weight: 500;
            margin-bottom: 1.8rem;
        }
        .question-content {
            opacity: 0.5;
            font-family: PingFangSC-Regular;
            font-size: 2.6rem;
            color: #1B1E3F;
            letter-spacing: 0;
            font-weight: 400;
        }
    }

    .specity-color {
        background-color: #F5F9FF;
        padding-bottom: 4rem;
    }

    .el-drawer {
        border-radius: 2rem 2rem 0 0;
        padding: 3rem;
    }
}
</style>